import { setToast } from '@/entities/toast'
import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

type UnlinkConstraintPayload = {
  id?: number
  orderAttributeId?: number
  vehicleAttributeId?: number
}

export const unlinkConstraint = createAsyncThunk('constraints/unlinkConstraint', async (payload: UnlinkConstraintPayload, { dispatch }) => {
  try {
    await OLMSApiService.post<void>('/constraint/unlink', payload)

    dispatch(setToast({
      open: true,
      severity: 'success',
      title: 'Unlink Constraint',
      content: 'Successfully unlinked constraints',
    }))

    return true
  } catch (error) {
    dispatch(setToast({
      open: true,
      severity: 'error',
      title: 'Unlink Constraint',
      content: 'Failed to unlink constraints',
    }))

    throw error
  }
})